import React from 'react';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';

import { EndringsMelding } from 'services/QAApi/types';

import Style from './index.module.css';
import { IcebergButton } from '@tradesolution/iceberg-ui-react';

interface Props {
  changeRequest: EndringsMelding;
  submitDisabled: boolean;
  folgesOppLoading: boolean;
  submitLoading: boolean;
  onFolgesOppClicked: () => void;
  onIgnoreClicked: () => void;
  onSubmitClicked: () => void;
  onAvvisClicked: () => void;
}

const DetailStickyFooter = (props: Props) => {
  return (
    <div className={Style.footerContainer}>
      <ButtonToolbar className={Style.actionBtnToolbar}>
        <IcebergButton
          variant="outline-primary"
          size="sm"
          className="me-2"
          disabled={
            !!(
              props.changeRequest.status === 'Avvist' || props.changeRequest.status === 'Behandlet'
            )
          }
          onClick={() => props.onFolgesOppClicked()}
          isLoading={props.folgesOppLoading}
        >
          <span>
            {props.changeRequest.status === 'FolgesOpp' ? 'Stans oppfølging' : 'Følg opp'}
          </span>
        </IcebergButton>
        <IcebergButton
          variant="outline-primary"
          size="sm"
          className="me-2"
          disabled={
            !!(
              props.changeRequest.status === 'Avvist' || props.changeRequest.status === 'Behandlet'
            )
          }
          onClick={props.onAvvisClicked}
        >
          <span>Avvis</span>
        </IcebergButton>
        <IcebergButton
          variant="outline-primary"
          size="sm"
          className="me-2"
          disabled={
            !!(
              props.changeRequest.status === 'Behandlet' || props.changeRequest.status === 'Avvist'
            )
          }
          onClick={props.onIgnoreClicked}
        >
          <span>Ignorer</span>
        </IcebergButton>
        <IcebergButton
          variant="primary"
          size="sm"
          disabled={props.submitDisabled}
          onClick={props.onSubmitClicked}
          isLoading={props.submitLoading}
        >
          <span>Lagre</span>
        </IcebergButton>
      </ButtonToolbar>
    </div>
  );
};

export default DetailStickyFooter;
